import React from 'react';
import { Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { FaShoppingCart, FaTag, FaCircle } from 'react-icons/fa';
import './StoreBookSidebar.scss';

const StoreBookSidebar = ({ 
  bookCategories, 
  selectedMenu, 
  selectedChildCode, 
  onChildMenuClick 
}) => {
  return (
    <aside className="store-sidebar">
      <div className="sidebar-header">
        <h3 className="sidebar-title">
          교재 구매
        </h3>
      </div>
      <Menu className="store-menu">
        {bookCategories.map((category) => (
          <SubMenu 
            key={category.parent_code}
            label={category.parent_unit}
            icon={category.icon}
            defaultOpen={selectedMenu === category.parent_code}
            className="parent-menu"
          >
            {/* 자식 카테고리들 */}
            {category.children.map((child) => (
              <MenuItem 
                key={child.child_code}
                icon={<FaCircle style={{ fontSize: '0.4rem' }} />}
                onClick={() => onChildMenuClick(category.parent_code, child.child_code)}
                active={selectedMenu === category.parent_code && selectedChildCode === child.child_code}
                className="child-menu-item"
              >
                {child.child_unit}
              </MenuItem>
            ))}
          </SubMenu>
        ))}
      </Menu>
    </aside>
  );
};

export default StoreBookSidebar;
